/**
 * Authors: Koen, mariushirjanu, Triadi
 * Created: 07/11/2018
 * Upgraded: 28/10/2022
 */
import { Subscription } from 'rxjs';
import { Component, Input, OnInit, OnDestroy, Type } from '@angular/core';
import { GaWizard, IWizardStep, WizardEvent } from './ga-wizard';
import { GaWizardService } from './ga-wizard.service';
import { GaEventService, IGAEvent } from '../services/ga-event.service';
import { TransitionService } from '@uirouter/angular';
import { ScrollService } from '../scroll/scroll.service';

@Component({
  selector: 'wizard-content',
  template: `
    <div class="wizard-sidenav-list d-md-none d-lg-block" *ngIf="hasSidebarNavigation">
      <ul class="nav flex-column nav-list margin-top-md">
        <li *ngFor="let step of steps; let idx = index; trackById" [class.active]="idx === activeStepIndex" class="nav-item">
          <a href role="menuitem" (click)="selectStep($event, idx)" translate>
            {{ step.title }}
            <i class="fa fa-angle-right"></i>
          </a>
        </li>
      </ul>
    </div>

    <div class="wizard-content" [class.has-sidebar]="hasSidebarNavigation" ui-view *ngIf="stateSynced"></div>
    <div class="wizard-content wizard-synced" [class.has-sidebar]="hasSidebarNavigation" *ngIf="!stateSynced">
      <ndc-dynamic [ndcDynamicComponent]="currentStateComponent" [ndcDynamicInputs]="{ isInDialog: isInDialog }"></ndc-dynamic>
    </div>
  `
})
export class WizardContentComponent implements OnInit, OnDestroy {
  @Input() public wizardId:string;
  @Input() public isInDialog:boolean;
  public steps:IWizardStep[];
  public activeStepIndex:number;
  public stateSynced:boolean;
  public currentStateComponent:Type<any>;
  public wizard:GaWizard;
  public hasSidebarNavigation:boolean;
  private eventHandler:Subscription;
  private onStateSuccessHandler:Function;

  constructor(
    private gaEventService:GaEventService,
    private wizardService:GaWizardService,
    private transitionService:TransitionService,
    private scrollService:ScrollService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.wizard = this.wizardService.getInstance(this.wizardId);
    this.hasSidebarNavigation = this.wizard.hasSidebarNavigation;
    this.steps = this.wizard.visibleSteps();
    this.activeStepIndex = this.wizard.activeStepIndex;
    this.stateSynced = this.wizard.stateSynced;
    this.currentStateComponent = this.wizard.steps()[ this.wizard.activeStepIndex ]?.component;
    this.listen();
  }

  private listen():void {
    this.eventHandler = this.gaEventService.events.subscribe((event:IGAEvent) => {
      if (event.name === `${WizardEvent.STEP_SELECTION_CHANGED}.${this.wizardId}`) {
        this.currentStateComponent = this.wizard.steps()[event.data]?.component;
        this.activeStepIndex = event.data;
        this.steps = this.wizard.visibleSteps();
      } else if (event.name === `${WizardEvent.SYNC}.${this.wizardId}`) {
        this.steps = this.wizard.visibleSteps();
      }
    });

    if (!this.isInDialog) {
      this.onStateSuccessHandler = this.transitionService.onSuccess({}, () => {
        // always scrolling to top after state change
        this.scrollService.scrollToElement('#ga2-content', undefined, true);
      });
    }
  }

  public selectStep(event:Event, idx:number):void {
    event.preventDefault();
    this.wizard.selectStep(idx);
  }

  public ngOnDestroy():void {
    this.eventHandler.unsubscribe();
    if (!this.isInDialog) {
      this.onStateSuccessHandler();
    }
  }
}